module.exports = __webpack_public_path__ + "img/510.414211c1.png";